import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  refreshAnalyticsToken: `${NAMESPACE}_REFRESH_ANALYTICS_TOKEN`,
  setAnalyticsToken: `${NAMESPACE}_SET_ANALYTICS_TOKEN`,
  checkAnalyticsHealth: `${NAMESPACE}_CHECK_ANALYTICS_HEALTH`,
  setAnalyticsHealth: `${NAMESPACE}_SET_ANALYTICS_HEALTH`,
}

export const actionCreators = {
  refreshAnalyticsToken: () => ({ type: actions.refreshAnalyticsToken }),
  setAnalyticsToken: (payload) => ({ type: actions.setAnalyticsToken, payload }),
  checkAnalyticsHealth: () => ({ type: actions.checkAnalyticsHealth }),
  setAnalyticsHealth: (payload) => ({ type: actions.setAnalyticsHealth, payload })
}

export default {
  actions,
  actionCreators
};
